export default {
  title: 'ツールを選択',
  dmaker: {
    title: 'カスタムクリエイティブ',
    subtitle: 'Mindworksでカスタマイズしたすべての広告素材',
  },
  gmaker: {
    title: 'インタラクティブ広告制作',
    subtitle:
      'Mindworksが提供する一般的なテンプレートを使用して、コンテンツエディタを使用してインタラクティブな広告を迅速に制作',
  },
  vmaker: {
    title: '動画広告の作成',
    subtitle: 'スマートな編集 バッチ処理',
  },
}
